import type { IHsdqOsasQuestionnaire } from '@common/interfaces';
import type { IProcessQuestionnaireResponseItem } from '@common/interfaces/api/processQuestionnaireResponsesApi';
// mapping functions for osas flex

// @TODO CS-21188 replace with migration
export const hsdqQuestionnairePrefixMappingToKeys: { [key: string]: string } = {
    osasHsdq01: 'fatigueDuringTheDay',
    osasHsdq02: 'annoyingItchy',
    osasHsdq03: 'dryMouth',
    osasHsdq04: 'screaming',
    osasHsdq05: 'difficultyWakingUp',
    osasHsdq06: 'restlessLegs',
    osasHsdq07: 'poorSleep',
    osasHsdq08: 'urgeToMoveLegs',
    osasHsdq09: 'moveLegs',
    osasHsdq10: 'lieAwake',
    osasHsdq11: 'kickingLegMovements',
    osasHsdq12: 'concerned',
    osasHsdq13: 'troublesFallingAsleep',
    osasHsdq14: 'consequencesAfterBadNight',
    osasHsdq15: 'iDontGetEnoughSleep',
    osasHsdq16: 'vividDream',
    osasHsdq17: 'stopBreathing',
    osasHsdq18: 'snoreLoudly',
    osasHsdq19: 'suffocation',
    osasHsdq20: 'nightmares',
    osasHsdq21: 'functionLessWell',
    osasHsdq22: 'sometimesInjured',
    osasHsdq23: 'fallAsleepRepeatedly',
    osasHsdq24: 'confusedHalfAwake',
    osasHsdq25: 'iDontFeelRestedAfterNap',
    osasHsdq26: 'normalTime',
    osasHsdq27: 'sleepBadlyDuringDay',
    osasHsdq28: 'moreThanTenHours',
    osasHsdq29: 'sleepAttacks',
    osasHsdq30: 'timeVaries',
    osasHsdq31: 'sleepWalking',
    osasHsdq32: 'unintentionallyFallAsleepDuringDay',
};

export const essQuestionnairePrefixMappingToKeys: { [key: string]: string } = {
    osasEss01: 'whenReading',
    osasEss02: 'whenWatchingTv',
    osasEss03: 'inAPublicEnvironment',
    osasEss04: 'sittingInACarAsPassenger',
    osasEss05: 'restingInTheAfternoon',
    osasEss06: 'talkingToSomeone',
    osasEss07: 'afterLunch',
    osasEss08: 'waitingInTheCarInTraffic',
};

export function getMappedQuestionnaireResponseAnswers(items: IProcessQuestionnaireResponseItem[]) {
    const mappedAnswers: { [key: string]: number } = {};

    for (const item of items) {
        const key =
            hsdqQuestionnairePrefixMappingToKeys[item.prefix as keyof typeof hsdqQuestionnairePrefixMappingToKeys];

        mappedAnswers[key] = item.answer.itemWeight ?? 0;
    }

    return mappedAnswers as Partial<IHsdqOsasQuestionnaire>;
}

export function getQuestionnaireResponseScore(items: IProcessQuestionnaireResponseItem[], isAverage: boolean): number {
    const totalScore = items.reduce((sum, item) => sum + (item.answer.itemWeight ?? 0), 0);

    if (!isAverage) {
        return totalScore;
    }

    const average = totalScore / items.length;

    return Number(average.toFixed(2));
}
